import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Container from '../../../Container/Container';

import {
  TXTCLI_Country_of_Residence,
  TXTWCL_WeXll_use_this_to_make_sure_yo_ELL,
  TXTWCL_WhereXs_homeX
} from './SignupCountry.messages.json';
import SignupCountrySelect from './components/SignupCountrySelect/SignupCountrySelect';

const SignupCountry: React.FunctionComponent = () => (
  <Container
    page={SignupCountry}
    headerProps={{
      title: <Translation {...TXTCLI_Country_of_Residence} />,
      withImage: true,
      buttons: { back: false }
    }}
    pageTopTitle={<Translation {...TXTWCL_WhereXs_homeX} />}
    pageTopSubtitle={<Translation {...TXTWCL_WeXll_use_this_to_make_sure_yo_ELL} />}
  >
    <SignupCountrySelect />
  </Container>
);

SignupCountry.displayName = 'SignupCountry';

export default SignupCountry;
